import { Menu } from '@mantine/core'
import type { ButtonProps } from 'components/Button/Button'
import { Button } from 'components/Button/Button'
import { IconChevron } from 'components/icons/IconChevron'
import { MobileSettingsDrawer } from 'components/MobileSettingsDrawer/MobileSettingsDrawer'
import type { StackedChartSection } from 'components/StackedChart/types'
import type { ReactNode } from 'react'
import React, { useState } from 'react'
import { useIsWideScreen } from 'utils/useIsWideScreen'

type DropdownButtonProps = {
  options?: NonNullable<StackedChartSection['titleLink']>
  desktopOutsideMobileDropdownOptions?: ReactNode
  showChevronIcon?: boolean
} & ButtonProps

export const DropdownButton = ({
  options,
  desktopOutsideMobileDropdownOptions,
  showChevronIcon = true,
  ...buttonProps
}: DropdownButtonProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [mobileSettingsDrawerOpen, setMobileSettingsDrawerOpen] = useState(false)
  const isWideScreen = useIsWideScreen()

  const ButtonComponent = ({ onClick }: { onClick?: () => void }) => {
    return (
      <Button
        {...buttonProps}
        rightIcon={
          showChevronIcon && (
            <IconChevron width={'11px'} rotate={dropdownOpen || mobileSettingsDrawerOpen} transition={true} />
          )
        }
        onClick={onClick}
        variant="secondary"
        gap={6}
        css={{ paddingLeft: '8px', paddingRight: '8px', height: '34px' }}
      />
    )
  }

  const DesktopDropdownButton = () => {
    return options && options.length > 0 ? (
      <Menu
        position={'bottom-end'}
        shadow="md"
        width={'auto'}
        offset={1}
        withinPortal={true}
        onChange={setDropdownOpen}
        opened={dropdownOpen}
      >
        <Menu.Target>
          <div>
            <ButtonComponent />
          </div>
        </Menu.Target>

        <Menu.Dropdown>
          {options?.map((option, index) => (
            <div key={index}>
              {option}
              {index < options.length - 1 && <Menu.Divider />}
            </div>
          ))}
        </Menu.Dropdown>
      </Menu>
    ) : null
  }

  return isWideScreen ? (
    <>
      {desktopOutsideMobileDropdownOptions ? (
        <div
          css={{
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '4px 12px',
          }}
        >
          <span>{desktopOutsideMobileDropdownOptions}</span>
          <DesktopDropdownButton />
        </div>
      ) : (
        <DesktopDropdownButton />
      )}
    </>
  ) : (
    <>
      <ButtonComponent onClick={() => setMobileSettingsDrawerOpen(!mobileSettingsDrawerOpen)} />
      <MobileSettingsDrawer
        opened={mobileSettingsDrawerOpen}
        onClose={() => setMobileSettingsDrawerOpen(false)}
        options={options}
        optionsTop={desktopOutsideMobileDropdownOptions}
      />
    </>
  )
}
